import reportingEntityServices from "../../services/reportingEntity";
const getDefaultState = () => {
    return {
        ReportingEntity: {
            ID: 0,
            LegalEntity: null,
            EntityName: null,
            Agency: null,
            AgencyName: null,
            Location: null,
            Department: null,
            SuggestedEntity: null,
            HFMEntity: null,
            IsMediaAssociated: null,
            IsMediaOfficeSetUpInMO: null,
            IsRequiredInReach: null,
            IsChangeInReportingEntity: null,
            AlternateSubsetsOrRollups: null,
            CurrentHFMEntity: null,
            ExistingRollupsToRemove: null,
            Status: null,
        }
    };
};

// initial state
const state = getDefaultState();

// getters
const getters = {
    ReportingEntity: (state) => {
        return state.ReportingEntity;
    },
};

// actions
const actions = {
    GetReportingEntityRequestWithTaskDetails(st, obj) {
        return reportingEntityServices.GetReportingEntityRequestWithTaskDetails(
            obj,
            st.rootState.auth.idToken
        );
    },
    AddRequest(st, data) {
        return reportingEntityServices.AddRequest(data, st.rootState.auth.idToken);
    },
    ApproveRequest(st, data) {
        return reportingEntityServices.ApproveRequest(
            data,
            st.rootState.auth.idToken
        );
    },
    RejectRequest(st, data) {
        return reportingEntityServices.RejectRequest(
            data,
            st.rootState.auth.idToken,
            "Reject"
        );
    },
    GetRequests(st, options) {
        return reportingEntityServices.GetRequests(st.rootState.auth.idToken, options);
    },
    WorkflowHistoryStates(st, id) {
        return reportingEntityServices.WorkflowHistoryStates(id, st.rootState.auth.idToken);
    },
    DownloadList(st, data) {
        return reportingEntityServices.DownloadList(st.rootState.auth.idToken, data);
    },
    UpdateReportingEntityRequest(st, { id, data }) {
        return reportingEntityServices.UpdateReportingEntityRequest(
            id,
            data,
            st.rootState.auth.idToken
        );
    },
};

// mutations
const mutations = {
    reset(st) {
        const s = getDefaultState();
        Object.keys(st).forEach((d) => {
            st[d] = s[d];
        });
    },
    loadReportingEntityData(state, data) {
        Object.assign(state.ReportingEntity, data);
        state.ReportingEntity.Status = data.Status;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};